<h2>{{ 'VERSIONS' | transloco }}</h2>
<p>Platform: {{ platform }}</p>
<p>App Version: {{ env }}-{{ appVersion }}</p>
